import "./ProductsSection.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faApple, faGooglePlay, faAndroid } from "@fortawesome/free-brands-svg-icons";
import phoneImg from "../images/phone.png";
import TradeCard from './TradeCard';

const products = [
  {
    title: "Spot Trading",
    description:
      "Buy and sell crypto instantly with real-time market prices. Perfect for beginners and pros alike.",
  },
  {
    title: "Futures Trading",
    description:
      "Trade like a whale with diverse futures markets. Smarter, faster, and bigger — all in one powerful platform.",
  },
  {
    title: "Unified Trading Account",
    description:
      "Automate your trades 24/7 with AI-powered bots. Manage strategies across accounts effortlessly.",
  },
];

const ProductsSection = () => (
  <section>
  <section className="products-section">
    <div className="container">
    <h2 className="products-title">DISCOVER MORE PRODUCTS</h2>
      <div className="row justify-content-center">
        {products.map((product, idx) => (
          <div className="col-12 col-md-6 col-lg-4 mb-4" key={idx}>
            <div className="product-card h-100">
              <div className="product-title d-flex justify-content-between align-items-center">
                {product.title}
                <span className="chevron">
                  <FontAwesomeIcon icon={faChevronRight} size='1px'/>
                </span>
              </div>
              <div className="product-desc">{product.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  <TradeCard />
  </section>
);

export default ProductsSection;